import Marquee from "react-fast-marquee";
import { useLang } from "../i18n";

export const EditorialMarquee = () => {
  const { t, isAr, lang } = useLang();
  return (
    <div className="py-6 border-b border-line bg-paper overflow-hidden" data-testid="editorial-marquee" dir="ltr">
      <Marquee key={lang} speed={28} gradient={false} pauseOnHover direction={isAr ? "right" : "left"}>
        {t.marquee.map((item, i) => (
          <span key={i} className="flex items-center gap-8 mx-8">
            <span
              className={`text-sm uppercase tracking-[0.25em] text-smoke whitespace-nowrap ${
                /[\u0600-\u06FF]/.test(item) ? "font-arabic normal-case tracking-normal text-gold text-base" : "font-body"
              }`}
            >
              {item}
            </span>
            <span className="w-1.5 h-1.5 rotate-45 bg-heart/70 inline-block" />
          </span>
        ))}
      </Marquee>
    </div>
  );
};
